import React, { useState, useEffect } from 'react'
import { Loader } from 'semantic-ui-react'
import { size, map } from "lodash"
import { Work, Favorite } from '../../../api'
import { useAuth } from '../../../hooks'
import { FavoriteItem } from '../FavoriteItem/FavoriteItem'

const workController = new Work()
const favoritecontroller = new Favorite()

export function ListFavorites(props) {
    const { worksActive, reload, onReload, datos } = props
    const [ works, setWorks ] = useState(null)
    const [ favorites, setFavorites ] = useState(null)
    const [ search, setSearch] = useState(works)

    const { user, accessToken } = useAuth()

    useEffect(()=>{
        if(works!==null){
            filterWorks(datos)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[datos])

    const filterWorks = (datos) =>{
        if(datos!==""){
            // eslint-disable-next-line array-callback-return
            let result = works.filter((Element)=>{
                let Names = Element.name || ""
                let Users = Element.userWork || ""
                if(Names.toLowerCase().includes(datos.toLowerCase()) || Users.toLowerCase().includes(datos.toLowerCase())){
                    return Element
                }else{
                    // console.log("No encuentra resultados");
                }
            })
            setSearch(result)
        }else{
            setSearch(works)
        }
    }

    useEffect(() => {
        (async () => {
            try {
                setFavorites(null)
                const response = await favoritecontroller.getFavorite(accessToken, user)
                setFavorites(response)
            } catch (error) {
                console.error(error);
            }
        })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reload])

    useEffect(() => {
        (async () => {
            try {
                setWorks(null)
                const response = await workController.getWorks(worksActive)
                setWorks(response)
                setSearch(response)
            } catch (error) {
                console.error(error);
            }
        })()
    }, [worksActive, reload])

    if(!works) return <Loader active inline="centered" />
    if(size(works) === 0) return "No hay ningun trabajo"

  return map(search, (work) => <FavoriteItem key={work._id} work={work} onReload={onReload} favorite={favorites} />)
}